var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEisengardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "#2F2F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8483 23.351L5.34026 18.567L13.7863 12.9018L23.6325 17.791L14.8483 23.351Z",
    fill: "#2F2F2F",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8483 19.726L5.34026 14.942L13.7863 9.27684L23.6325 14.166L14.8483 19.726Z",
    fill: "#2F2F2F",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8483 16.101L5.34026 11.317L13.7863 5.65184L23.6325 10.541L14.8483 16.101Z",
    fill: "#2F2F2F",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4204 7.84826L13.6597 7.46802L12.7115 8.11208L9.94181 9.99356L8.98633 10.6426L10.0265 11.145L15.4639 13.771L19.2989 11.4047L20.2999 10.787L19.4961 10.3853L18.7996 10.8496L13.7246 8.31213L14.4204 7.84826ZM18.2468 10.8788L16.4154 9.96336L13.7469 11.8313L15.4052 12.6321L18.2468 10.8788ZM13.7368 8.62453L15.398 9.45486L12.7151 11.3329L10.9819 10.4959L13.7368 8.62453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEisengardLogo);
export default __webpack_public_path__ + "static/media/eisengard_logo.4de4589e00dc0d8419aa8698eaa13ea0.svg";
export { ForwardRef as ReactComponent };